module.exports = __webpack_public_path__ + "static/media/img-2.c6a12561.jpg";